export var ArticleLinkType;
(function (ArticleLinkType) {
    ArticleLinkType["Article"] = "article";
    ArticleLinkType["Survey"] = "survey";
    ArticleLinkType["Video"] = "video";
    ArticleLinkType["Whitepaper"] = "whitepaper";
})(ArticleLinkType || (ArticleLinkType = {}));
//# sourceMappingURL=articleLinkType.js.map